import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const ADMIN_MARKETPLACE_ITEMS = gql`
  query AdminMarketplaceItems($input: MarketplaceItemsFilterInput) {
    adminMarketplaceItems(input: $input) {
      items {
        _id
        name
        description
        shortDescription
        imageUrl
        koinsPrice
        category
        scope
        organizationId
        fulfillmentType
        fulfillmentInstructions
        totalInventory
        remainingInventory
        expiresAt
        sortOrder
        featured
        isActive
        metadata
        createdAt
        updatedAt
      }
      total
      hasMore
    }
  }
`;

export const ORGANIZATION_MARKETPLACE_ITEMS = gql`
  query OrganizationMarketplaceItems($input: OrganizationMarketplaceItemsInput!) {
    organizationMarketplaceItems(input: $input) {
      items {
        _id
        name
        description
        shortDescription
        imageUrl
        koinsPrice
        category
        scope
        organizationId
        fulfillmentType
        fulfillmentInstructions
        totalInventory
        remainingInventory
        expiresAt
        sortOrder
        featured
        isActive
        autoRefill
        refillQuantity
        refillDay
        lastRefilledAt
        metadata
        createdAt
        updatedAt
      }
      total
      hasMore
    }
  }
`;

export const ALL_ORDERS = gql`
  query AllOrders($input: AllOrdersFilterInput) {
    allOrders(input: $input) {
      orders {
        _id
        userId
        marketplaceItemId
        koinsSpent
        status
        fulfillmentDetails
        fulfilledAt
        cancelledAt
        cancellationReason
        createdAt
        updatedAt
        item {
          _id
          name
          category
          scope
          imageUrl
          fulfillmentType
          fulfillmentInstructions
        }
        user {
          _id
          firstName
          lastName
          email
        }
      }
      total
      hasMore
    }
  }
`;

export const ORGANIZATION_ORDERS = gql`
  query OrganizationOrders($input: OrganizationOrdersInput!) {
    organizationOrders(input: $input) {
      orders {
        _id
        userId
        marketplaceItemId
        koinsSpent
        status
        fulfillmentDetails
        fulfilledAt
        cancelledAt
        cancellationReason
        createdAt
        updatedAt
        item {
          _id
          name
          category
          scope
          imageUrl
          fulfillmentType
          fulfillmentInstructions
        }
        user {
          _id
          firstName
          lastName
          email
        }
      }
      total
      hasMore
    }
  }
`;

export const ORGANIZATION_ORDER_STATS = gql`
  query OrganizationOrderStats($organizationId: ID!) {
    organizationOrderStats(organizationId: $organizationId) {
      pendingCount
      fulfilledCount
      cancelledCount
      totalKoinsSpent
    }
  }
`;

// ─── Export (fetches all rows for CSV download) ─────────────────────────────

export const EXPORT_ORGANIZATION_ORDERS = gql`
  query ExportOrganizationOrders($input: OrganizationOrdersInput!) {
    organizationOrders(input: $input) {
      orders {
        _id
        koinsSpent
        status
        fulfillmentDetails
        fulfilledAt
        cancelledAt
        cancellationReason
        createdAt
        item {
          name
          category
        }
        user {
          firstName
          lastName
          email
        }
      }
      total
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const CREATE_MARKETPLACE_ITEM = gql`
  mutation CreateMarketplaceItem($input: CreateMarketplaceItemInput!) {
    createMarketplaceItem(input: $input) {
      _id
      name
      description
      shortDescription
      imageUrl
      koinsPrice
      category
      scope
      organizationId
      fulfillmentType
      fulfillmentInstructions
      totalInventory
      remainingInventory
      sortOrder
      featured
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MARKETPLACE_ITEM = gql`
  mutation UpdateMarketplaceItem($id: ID!, $input: UpdateMarketplaceItemInput!) {
    updateMarketplaceItem(id: $id, input: $input) {
      _id
      name
      description
      shortDescription
      imageUrl
      koinsPrice
      category
      scope
      organizationId
      fulfillmentType
      fulfillmentInstructions
      totalInventory
      remainingInventory
      sortOrder
      featured
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const DEACTIVATE_MARKETPLACE_ITEM = gql`
  mutation DeactivateMarketplaceItem($id: ID!) {
    deactivateMarketplaceItem(id: $id) {
      _id
      isActive
    }
  }
`;

export const FULFILL_ORDER = gql`
  mutation FulfillOrder($orderId: ID!, $fulfillmentDetails: String) {
    fulfillOrder(orderId: $orderId, fulfillmentDetails: $fulfillmentDetails) {
      _id
      status
      fulfillmentDetails
      fulfilledAt
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation CancelOrder($orderId: ID!, $reason: String!) {
    cancelOrder(orderId: $orderId, reason: $reason) {
      _id
      status
      cancellationReason
      cancelledAt
    }
  }
`;

// ─── Storage (Image Upload) ─────────────────────────────────────────────────
// Re-exported from shared location for backward compatibility
export { REQUEST_UPLOAD_URL, CONFIRM_UPLOAD } from "../../graphql/storage";
